import { Colors, FlexBox } from "@brg/ui"
import { LayoutConst } from 'core'
import styled, { css } from "styled-components"

export const SuccessPlaceWrapper = styled.div`
    width: 100%;
    height: 72vh;
    display: flex;
    justify-content: center;
`

export const SuccessWrapper = styled.div<{isSuccess?:boolean}>`
    width: 100%;
    // height: 80vh;
    height: fit-content;
    padding: 24px 0;
    overflow-y: scroll;
    max-width: min(90vw, 1152px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    border-radius: 8px;
    background:${p => p.isSuccess ? `${Colors.galBlack5}` : "#FFFFFF"} ;
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
    
    &::-webkit-scrollbar {
        width: 0px;
    };
   
    ${({isSuccess}) => (isSuccess) && css`
        padding: 32px 0;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            max-width: 888px;
            padding: 24px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100vw;
        padding: 10px;
        height: 90vh;
        
        ${({isSuccess}) => (isSuccess) && css`
            width: 100%;
            background: ${Colors.galBlack10};
            box-shadow: none;
            margin: 0 auto;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            width: calc(100vw - 20px);
            padding: 0;
            margin-top: 12px;
        `};
    };
`;

export const SuccessTitle = styled.div<{isSuccess?:boolean}>`
    font-family: Inter;
    font-size: 43px;
    font-weight: 600;
    line-height: 118.605%;
    text-align: center;
    color: ${Colors.galBlack100};
    letter-spacing: -0.86px;

    ${({isSuccess}) => (isSuccess) && css`
        margin-bottom: 16px;
        letter-spacing: -0.02em;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            font-size: 34px;
            line-height: 41px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 20px;
        line-height: 25px;

        ${({isSuccess}) => (isSuccess) && css`
            font-size: 34px;
            line-height: 41px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            font-size: 30px;
            line-height: 40px;
            margin-bottom: 8px;
        `};
    };
`;

export const SuccessText = styled.div`
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    max-width: 550px;
    color: ${Colors.galBlack61};

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    };
`;

export const SuccessSummaryWrapper = styled.div<{isSuccess?:boolean}>`
    display: flex;
    // width: 100%;
    gap: 24px;
    background: ${Colors.galBlack10};
    border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.md}px) {
        flex-direction: column;
        background-color: ${Colors.galBlack5};
        padding: 16px;

        ${({isSuccess}) => (isSuccess) && css`
            display: contents;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            width:100%;
        `};
    };
`;

export const SuccessCloseButton = styled.div`
    cursor: pointer;
    display: flex;
    padding: 12px 32px;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    border-radius: 3px;
    background: ${Colors.galBlack100};
    color: ${Colors.gal};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 129.412%;
    letter-spacing: -0.34px;
    width: 100%;
`;

export const SuccessWhiteButton = styled(SuccessCloseButton)<{whithoutBg?:boolean}>`
    background: ${p => p.whithoutBg? `transparent`: `${Colors.gal}`};
    color: ${Colors.galBlack100};
    border: 1px solid ${Colors.galBlack31};
`;

export const SuccessPaymentText = styled.div`
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.02em;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    color: ${Colors.galBlack73};
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    };

    // @media (max-width: ${LayoutConst.screen.md}px) {
    //     margin-bottom: 8px;
    // };
`;

export const SuccessInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 500px;
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        height:100%; 
        justify-content: space-between; 
    };
`;

export const SuccessButtonsBlock = styled(FlexBox)<{isSuccess?:boolean}>`
    width: 540px;
    gap: 24px;
    justify-content:space-between;

    ${({isSuccess}) => (isSuccess) && css`
        display:grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        width: 100%;
        margin-top:24px;

        >div {
            margin-top:0;
        };
    `};


    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            >div {
                font-size: 15px;
                line-height: 20px;
            }
        `};
    };


     @media (max-width: ${LayoutConst.screen.md}px) {
        ${({isSuccess}) => (isSuccess) && css`
            gap: 16px;
            // margin-top:8px;
        `}
    };

     @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            gap: 10px;
            grid-template-columns: 1fr;
            margin-top: 32px;
            display: flex;
            flex-direction: column-reverse;
            padding-bottom:4px;
        `}
    };
`;
import { Colors, FlexBox } from "@brg/ui"
import { LayoutConst } from 'core'
import styled, { css } from "styled-components"

export const SuccessPlaceWrapper = styled.div`
    width: 100%;
    height: 72vh;
    display: flex;
    justify-content: center;
`

export const SuccessWrapper = styled.div<{isSuccess?:boolean}>`
    width: 100%;
    // height: 80vh;
    height: fit-content;
    padding: 24px 0;
    overflow-y: scroll;
    max-width: min(90vw, 1152px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    border-radius: 8px;
    background:${p => p.isSuccess ? `${Colors.galBlack5}` : "#FFFFFF"} ;
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
    
    &::-webkit-scrollbar {
        width: 0px;
    };
   
    ${({isSuccess}) => (isSuccess) && css`
        padding: 32px 0;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            max-width: 888px;
            padding: 24px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100vw;
        padding: 10px;
        height: 90vh;
        
        ${({isSuccess}) => (isSuccess) && css`
            width: 100%;
            background: ${Colors.galBlack10};
            box-shadow: none;
            margin: 0 auto;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            width: calc(100vw - 20px);
            padding: 0;
            margin-top: 12px;
        `};
    };
`;

export const SuccessTitle = styled.div<{isSuccess?:boolean}>`
    font-family: Inter;
    font-size: 43px;
    font-weight: 600;
    line-height: 118.605%;
    text-align: center;
    color: ${Colors.galBlack100};
    letter-spacing: -0.86px;

    ${({isSuccess}) => (isSuccess) && css`
        margin-bottom: 16px;
        letter-spacing: -0.02em;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            font-size: 34px;
            line-height: 41px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 20px;
        line-height: 25px;

        ${({isSuccess}) => (isSuccess) && css`
            font-size: 34px;
            line-height: 41px;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            font-size: 30px;
            line-height: 40px;
            margin-bottom: 8px;
        `};
    };
`;

export const SuccessText = styled.div`
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    max-width: 550px;
    color: ${Colors.galBlack61};

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    };
`;

export const SuccessSummaryWrapper = styled.div<{isSuccess?:boolean}>`
    display: flex;
    // width: 100%;
    gap: 24px;
    background: ${Colors.galBlack10};
    border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.md}px) {
        flex-direction: column;
        background-color: ${Colors.galBlack5};
        padding: 16px;

        ${({isSuccess}) => (isSuccess) && css`
            display: contents;
        `};
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            width:100%;
        `};
    };
`;

export const SuccessCloseButton = styled.div`
    cursor: pointer;
    display: flex;
    padding: 12px 32px;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    border-radius: 3px;
    background: ${Colors.galBlack100};
    color: ${Colors.gal};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 129.412%;
    letter-spacing: -0.34px;
    width: 100%;
`;

export const SuccessWhiteButton = styled(SuccessCloseButton)<{whithoutBg?:boolean}>`
    background: ${p => p.whithoutBg? `transparent`: `${Colors.gal}`};
    color: ${Colors.galBlack100};
    border: 1px solid ${Colors.galBlack31};
`;

export const SuccessPaymentText = styled.div`
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.02em;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    color: ${Colors.galBlack73};
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    };

    // @media (max-width: ${LayoutConst.screen.md}px) {
    //     margin-bottom: 8px;
    // };
`;

export const SuccessInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 500px;
    };

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        height:100%; 
        justify-content: space-between; 
    };
`;

export const SuccessButtonsBlock = styled(FlexBox)<{isSuccess?:boolean}>`
    width: 540px;
    gap: 24px;
    justify-content:space-between;

    ${({isSuccess}) => (isSuccess) && css`
        display:grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        width: 100%;
        margin-top:24px;

        >div {
            margin-top:0;
        };
    `};


    @media (max-width: ${LayoutConst.screen.mac13}px) {
        ${({isSuccess}) => (isSuccess) && css`
            >div {
                font-size: 15px;
                line-height: 20px;
            }
        `};
    };


     @media (max-width: ${LayoutConst.screen.md}px) {
        ${({isSuccess}) => (isSuccess) && css`
            gap: 16px;
            // margin-top:8px;
        `}
    };

     @media (max-width: ${LayoutConst.screen.s}px) {
        ${({isSuccess}) => (isSuccess) && css`
            gap: 10px;
            grid-template-columns: 1fr;
            margin-top: 32px;
            display: flex;
            flex-direction: column-reverse;
            padding-bottom:4px;
        `}
    };
`;
